/**
 * @generated SignedSource<<87c165df1dd3e6b4cdca7c50f0d5d575>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type formatCreatorsAttribute_viewer$data = {
  readonly creatorProperties: ReadonlyArray<{
    readonly name: string | null;
    readonly propertyName: string | null;
    readonly urlLabel: string | null;
  } | null> | null;
  readonly " $fragmentType": "formatCreatorsAttribute_viewer";
};
export type formatCreatorsAttribute_viewer$key = {
  readonly " $data"?: formatCreatorsAttribute_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"formatCreatorsAttribute_viewer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "formatCreatorsAttribute_viewer"
};

(node as any).hash = "948f2b76576ba83a7ad54fb0a2098f7c";

export default node;
